import { render, staticRenderFns } from "./Freezers.vue?vue&type=template&id=7d056c32&"
import script from "./Freezers.vue?vue&type=script&lang=js&"
export * from "./Freezers.vue?vue&type=script&lang=js&"
import style0 from "./Freezers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports